import { Injectable } from '@angular/core';
import { EmailSharingCommand } from '../core-data-model/EmailList.model';
import { Job } from '../core-data-model/Job.model';
import { Person } from '../core-data-model/Person.model';

@Injectable()
export class CoachingGuideConfig {
    job: Job;
    person: Person;
    dropdownConfig: CoachingGuideConfigItem[];
    isPrintableStyle = false;
}

export class CoachingGuideConfigItem {
    factor: string;
    bulletPointText: string[];
}

export interface CoachingGuideReportRequest {
    coachingGuideConfig: CoachingGuideConfig;
    emailSettings?: EmailSharingCommand;
    companyId?: string;
    languageLocale: string;
}
